import React from 'react';
import { AnnouncementBar } from './components/AnnouncementBar';
import { Hero } from './components/Hero';
import { PainSection } from './components/PainSection';
import { RevelationSection } from './components/RevelationSection';
import { ExpertsSection } from './components/ExpertsSection';
import { TestimonialSection } from './components/TestimonialSection';
import { ReasonWhySection } from './components/ReasonWhySection';
import { ValueStack } from './components/ValueStack';
import { GuaranteeSection } from './components/GuaranteeSection';
import { CloseSection } from './components/CloseSection';
import { Footer } from './components/Footer';
import { FloatingCta } from './components/FloatingCta';
import { FloatingWhatsApp } from './components/FloatingWhatsApp';
export function App() {
  return <div className="min-h-full w-full bg-brand-dark font-sans text-zinc-200" data-id="element-0">
      <AnnouncementBar data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <PainSection data-id="element-4" />
        <RevelationSection data-id="element-5" />
        <ExpertsSection data-id="element-6" />
        <TestimonialSection data-id="element-7" />
        <ReasonWhySection data-id="element-8" />
        <ValueStack data-id="element-9" />
        <GuaranteeSection data-id="element-10" />
        <CloseSection data-id="element-11" />
      </main>
      <Footer data-id="element-12" />
      <FloatingCta data-id="element-13" />
      <FloatingWhatsApp data-id="element-14" />
    </div>;
}